import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// TODO: Replace with your Firebase project configuration
// Get these values from Firebase Console > Project Settings > General > Your apps > Firebase SDK snippet
const firebaseConfig = {
  apiKey: "AIzaSyDfgU2ny3JLIcvoeAHlDzNNZyNa51MznWQ",

  authDomain: "wixon-cross-defect-tracker.firebaseapp.com",

  projectId: "wixon-cross-defect-tracker",

  storageBucket: "wixon-cross-defect-tracker.firebasestorage.app",

  messagingSenderId: "203785692645",

  appId: "1:203785692645:web:37d0695fa938bb50e5fb0c",

  measurementId: "G-8LH9ZCW9L5",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Storage
export const storage = getStorage(app);

// Initialize Authentication
export const auth = getAuth(app);
